module.exports = __webpack_public_path__ + "static/media/FramePurple.2fadac9f.png";